(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cg-preorder-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-preorder-box')) {
  class CGPreorderBox extends HTMLElement {
    connectedCallback() {
      this.refreshDate();
      if (this.dataset.mode !== 'rolling') return;
      this.onVisibility = () => { if (!document.hidden) this.refreshDate(); };
      this.onFocus = () => this.refreshDate();
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('focus', this.onFocus);
      this.timer = window.setInterval(() => this.refreshDate(), 30000);
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('focus', this.onFocus);
    }
    refreshDate() {
      if (this.dataset.mode !== 'rolling') return;
      const days = Number(this.dataset.leadDays);
      if (!Number.isInteger(days) || days < 1 || days > 90) return;
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const dateParts = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const date = new Date(Date.UTC(Number(dateParts.year), Number(dateParts.month) - 1, Number(dateParts.day) + days, 12));
      const dateKey = date.toISOString().slice(0, 10);
      if (this.dispatchDateKey === dateKey) return;
      this.dispatchDateKey = dateKey;
      const longDate = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', year: 'numeric', month: 'long', day: 'numeric' }).format(date);
      for (const output of this.querySelectorAll('[data-cg-batch-offset]')) {
        const offset = Number(output.dataset.cgBatchOffset);
        if (!Number.isInteger(offset) || Math.abs(offset) > 90) continue;
        const batchDate = new Date(date.getTime());
        batchDate.setUTCDate(batchDate.getUTCDate() + offset);
        const day = batchDate.getUTCDate();
        const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
        const month = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', month: 'long' }).format(batchDate);
        output.textContent = month + ' ' + day + suffix;
        output.dateTime = batchDate.toISOString().slice(0, 10);
      }
      const scope = this.closest('cg-product, cg-bundle');
      if (!scope) return;
      scope.dataset.preorderDate = longDate;
      scope.dataset.preorderLabel = this.dataset.orderTemplate.replace('__DATE__', longDate);
      const input = scope.querySelector('input[name="properties[Pre-order]"]');
      if (input) input.value = scope.dataset.preorderLabel;
    }
  }
  customElements.define('cg-preorder-box', CGPreorderBox);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cg-shipping-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-shipping-banner')) {
  class CGShippingBanner extends HTMLElement {
    static detection;
    connectedCallback() {
      this.guaranteeLink = this.querySelector('[data-cg-guarantee-link]');
      this.onGuaranteeClick = event => {
        const target = document.getElementById(this.guaranteeLink.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.open = true;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        target.querySelector('summary')?.focus({ preventScroll: true });
      };
      this.guaranteeLink?.addEventListener('click', this.onGuaranteeClick);
      this.flag = this.querySelector('.cg-shipping-flag img');
      this.onFlagError = () => {
        this.flag.hidden = true;
        this.querySelector('[data-cg-flag-fallback]').hidden = false;
      };
      this.flag?.addEventListener('error', this.onFlagError);
      this.updateCountry({ handle: this.dataset.countryCode, name: this.dataset.countryName });
      if (window.Shopify?.designMode) return;
      if (!CGShippingBanner.detection) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 4000);
        const root = window.Shopify?.routes?.root || '/';
        CGShippingBanner.detection = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin', signal: controller.signal })
          .then(response => response.ok ? response.json() : null)
          .then(result => result?.detected_values?.country || result?.suggestions?.[0]?.parts?.country || null)
          .catch(() => null)
          .finally(() => window.clearTimeout(timeout));
      }
      CGShippingBanner.detection.then(country => {
        if (this.isConnected && country) this.updateCountry(country);
      });
    }
    disconnectedCallback() {
      this.guaranteeLink?.removeEventListener('click', this.onGuaranteeClick);
      this.flag?.removeEventListener('error', this.onFlagError);
    }
    updateCountry(country) {
      const code = String(country?.handle || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(code) || !country?.name) return;
      this.querySelector('[data-cg-shipping-country]').textContent = country.name;
      if (this.flag) {
        const src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=64';
        if (this.flag.getAttribute('src') !== src) {
          this.flag.removeAttribute('srcset');
          this.flag.src = src;
          this.flag.hidden = false;
          this.querySelector('[data-cg-flag-fallback]').hidden = true;
        }
      }
      let countries;
      try { countries = JSON.parse(this.dataset.availableCountries || '[]'); } catch { countries = []; }
      this.querySelector('[data-cg-shipping-availability]').hidden = !countries.length || countries.includes(code);
    }
  }
  customElements.define('cg-shipping-banner', CGShippingBanner);
}
  } catch(e) { console.error(e); }
})();

})();
